import RemoteNoteRepository from './repositories/RemoteNoteRepository'
import RemoteNoteGen2Repository from './repositories/RemoteNoteGen2Repository'
import {ENVIRONMENTS} from '#/notes/components/definitions'

/**
* Instantiates the correct repository based on the env variable
* @returns {Repository} the instantiated repository
*/
const create = function (strategy) {
  switch (strategy) {
    case ENVIRONMENTS.GEN_3:
      return new RemoteNoteRepository()
    case ENVIRONMENTS.GEN_2:
      return new RemoteNoteGen2Repository()
    default:
      return new RemoteNoteRepository()
  }
}

export default create
